import { Injectable } from '@angular/core';
import { Contacts } from '../../models/contacts';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ContactsService {
    constructor(private http: HttpClient) { }

    public Insert(c: Contacts): Observable<Contacts> {
        //debugger;
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.post<Contacts>("http://www.culuccia.com/api/contacts/insert", c, { headers });
        //return this.http.post<Contacts>("https://localhost:44355/contacts/insert", c, { headers });
    }
}